import React, { Component } from 'react';
import { Link } from 'react-router-dom'

class HomeLink extends Component {
    render() {
        return (
            <div className="homelink">
                <div className="container">
                    <div className="linkdiv linkind-div">

                        <div className="linkind">
                            <div style={{ display: this.props.isArabic == true ? "flex" : "", flexDirection: this.props.isArabic == true ? "column-reverse" : "" }}>
                                {/* <div className="linkindtop">{this.props.isArabic == true ? 'في التمويل الإسلامي' : 'Islamic Financial'}</div> */}
                                <div className="linkindbottom"><a href='https://www.hbku.edu.qa/en/cis#sec1' target='_blank'>{this.props.isArabic == true ? 'المؤسسات المالية' : 'CIS PROGRAMS'}</a></div>

                            </div>
                        </div>
                        <div className="link_bord"></div>
                        <div className="linkind">
                            <div style={{ display: this.props.isArabic == true ? "flex" : "", flexDirection: this.props.isArabic == true ? "column-reverse" : "" }}>
                                {/* <div className="linkindtop">{this.props.isArabic == true ? 'في التمويل الإسلامي' : 'Islamic Finance'}</div> */}
                                <div className="linkindbottom"><a href='https://www.hbku.edu.qa/en/cis' target='_blank'>{this.props.isArabic == true ? 'الدوريات' : 'CIS RESEARCH CENTERS'}</a></div>
                            </div>
                        </div>
                        <div className="link_bord link_mob_hide"></div>


                        <div className="linkind">
                            <div style={{ display: this.props.isArabic == true ? "flex" : "", flexDirection: this.props.isArabic == true ? "column-reverse" : "" }}>
                                {/* <div className="linkindtop">{this.props.isArabic == true ? 'التمويل الإسلامي' : 'Islamic Finance'}</div> */}
                                <div className="linkindbottom"><Link to='/research/cluster'>{this.props.isArabic == true ? 'مجموعات البحوث' : 'CIS RESEARCH CLUSTER'}</Link></div>
                            </div>
                        </div>
                        <div className="link_bord link_mob_hide"></div>


                        <div className="linkind">
                            <div style={{ display: this.props.isArabic == true ? "flex" : "", flexDirection: this.props.isArabic == true ? "column-reverse" : "" }}>
                                {/* <div className="linkindtop">{this.props.isArabic == true ? 'في التمويل الإسلامي ' : 'Islamic Finance'}</div> */}
                                <div className="linkindbottom"><Link to={{pathname:'/cis_publication',paper:{tab:'paper'}}}>{this.props.isArabic == true ? 'أوراق العمل' : 'CIS WORKING PAPERS'}</Link></div>                 
                                       </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default HomeLink;